// ✅ src/components/AppLayout.js
import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import TopBar from "./TopBar";
import BottomNav from "./BottomNav";

export default function AppLayout() {
  const location = useLocation();

  // ✅ Show TopBar only on /home
  const showTopBar = location.pathname.startsWith("/home");

  return (
    <div style={S.shell}>
      {/* ✅ Top Bar only on Home */}
      {showTopBar && (
        <div style={S.topWrap}>
          <TopBar />
        </div>
      )}

      {/* ✅ Page content */}
      <div style={S.content}>
        <Outlet />
      </div>

      {/* ✅ Bottom Nav always visible */}
      <BottomNav />
    </div>
  );
}

const S = {
  shell: {
    minHeight: "100vh",
    background:
      "radial-gradient(1200px 650px at 18% 0%, rgba(236,72,153,.14), transparent 60%), " +
      "radial-gradient(900px 520px at 90% 18%, rgba(99,102,241,.14), transparent 55%), " +
      "linear-gradient(180deg,#fbfaf8 0%, #f7f2ee 55%, #fbf7f3 100%)",
    color: "#0f172a",
    paddingTop: 14,
  },

  topWrap: {
    position: "sticky",
    top: 0,
    zIndex: 1000,
    paddingBottom: 10,
    background:
      "linear-gradient(180deg, rgba(251,250,248,0.95) 0%, rgba(251,250,248,0.75) 50%, rgba(251,250,248,0) 100%)",
    backdropFilter: "blur(10px)",
  },

  content: {
    width: "min(980px, calc(100% - 24px))",
    margin: "14px auto 0",
    paddingBottom: 96,
    minHeight: "calc(100vh - 180px)",
  },
};
